import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MvMsalService } from '@aot/host-app-widgets-demo';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

constructor(
  public router: Router,
  private readonly mvMsalService: MvMsalService, private authService: MsalService
) { }

public ngAfterViewInit() : void{
   this.authService.handleRedirectObservable().subscribe({
        next: (result: AuthenticationResult | null) => {
          if (result) {
            this.mvMsalService.userAuthenticated(result);
            this.router.navigate(['/home']); // Redirect to home
           
          }else {
            // Check for active account on page refresh
            const activeAccount = this.authService.instance.getActiveAccount();
            if (activeAccount) {
                this.mvMsalService.userAuthenticated({account: activeAccount} as AuthenticationResult);
                this.router.navigate(['/home']); // Redirect to home
            } else {
                // Handle unauthenticated state
                this.loginToAD();
                console.log("User is not authenticated.");
                // Redirect to login or show login button
            }
        }
        },
        error: (error) => console.error(error)
      });
}

  public loginToAD(): void {
    window.dispatchEvent(new CustomEvent('loginToAD')); 
  }
}
